import React, { HTMLProps, ReactNode } from 'react';
import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import * as S from './styled';

export type TButtonSize = 'small' | 'medium' | 'large';
export type TButtonType = 'action' | 'primary' | 'secondary' | 'white' | 'ghost' | 'accent';

export type TButtonBaseProps = {
    size?: TButtonSize,
    bType?: TButtonType,
    Icon?: ReactNode,
    children?: ReactNode | ReactNode[] | undefined,
    rounded?: boolean,
    animation?: boolean,
    loading?: boolean,
    justifyContent?: 'space-between' | 'center',
    iconSide?: 'left' | 'right',
};

export type TButtonProps = TButtonBaseProps & Omit<HTMLProps<HTMLButtonElement>, 'size'>;

const Button = (
    {
        size = 'large',
        bType = 'action', // we cannot use the type attribute in this component because it's the global property of button
        rounded = false,
        animation = true,
        loading = false,
        iconSide = 'left',
        justifyContent,

        Icon,
        children,

        ...rest
    }: TButtonProps,
): JSX.Element => {
    const renderContent = () => {
        if (iconSide === 'left') {
            return (
                <>
                    {Icon}
                    {children}
                </>
            );
        }
        return (
            <>
                {children}
                {Icon}
            </>
        );
    };

    return (
        // @ts-ignore
        <S.StyledButton bType={bType} size={size} rounded={rounded} hasIcon={!!Icon} animation={animation} {...rest}>
            <S.Wrapper justifyContent={justifyContent}>
                {loading
                    ? (
                        <S.StyledThrobber
                            color={
                                ['primary', 'action', 'accent'].includes(bType)
                                    ? COLORS.TextWhite
                                    : COLORS.ButtonAccent
                            }
                            isLoading={true}
                        />
                    )
                    : renderContent()}
            </S.Wrapper>
        </S.StyledButton>
    );
};

export default styled(Button)``;
